module.exports = __webpack_public_path__ + "img/banner.9af0def.png";